<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>
              <i class="fa fa-align-justify"></i> Mon Compte
            </strong>
          </div>
          <b-form id="mon-compte">
            <b-row>
              <b-col sm="5" class="border-style">
                <b-form-group label="Nom :" :label-cols="3" :horizontal="true">
                  <b-form-text type="text">
                    <h5>{{ user.nom }}</h5>
                  </b-form-text>
                </b-form-group>
                <b-form-group label="Prénom :" :label-cols="3" :horizontal="true">
                  <b-form-text type="text">
                    <h5>{{ user.prenom }}</h5>
                  </b-form-text>
                </b-form-group>
                <b-form-group label="Email :" :label-cols="3" :horizontal="true">
                  <b-form-text type="text">
                    <h5>{{ user.email }}</h5>
                  </b-form-text>
                </b-form-group>
                <b-form-group label="Structure :" :label-cols="3" :horizontal="true">
                  <b-form-text type="text">
                    <h5>{{ user.structure.libelle }}</h5>
                  </b-form-text>
                </b-form-group>
                <b-form-group label="Profil :" :label-cols="3" :horizontal="true">
                  <b-form-text type="text">
                    <h5>{{ user.userProfil.libelle_affichage }}</h5>
                  </b-form-text>
                </b-form-group>
                <div slot="footer">
                  <b-button type="button" @click="editPasswd" size="md" variant="primary" class="mb-2">
                    <i class="fa fa-edit"></i> Changer mot de passe
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken, getUser } from '../../utils/auth'

export default {
  data() {
    return {
      user: getUser(),
      userDroits: [],
      checkedDroits: [],
      currentDroits: []
    };
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common["Authorization"] =
      getIdToken() + " " + getAccessToken();
    this.$axios.defaults.headers.common["Accept"] = "application/json";
    this.$axios.defaults.headers.common["Provider"] = getProvider();

    this.show();
  },
  computed: {
    groups() {
      this.userDroits = this.user.userDroits;
      for (var i = 0; i < this.userDroits.length; i++) {
        this.currentDroits.push({
          id: this.userDroits[i].id,
          text: this.userDroits[i].libelle,
          value: this.userDroits[i].libelle_technique,
          domaine: this.userDroits[i].domaine,
          category: this.userDroits[i].categorie
        });
      }
      let droitTree = _.groupBy(this.currentDroits, "domaine");
      droitTree = _.map(droitTree, function(droitGroup) {
        // get parent
        let parent = _.find(droitGroup, function(droit) {
          if (droit.domaine == droit.category) return droit.value;
          //return droit.value.startsWith("can_access");
        });
        // get children
        let children = _.filter(droitGroup, function(droit) {
          if (droit.domaine != droit.category) return droit.value;
          //return !droit.value.startsWith("can_access");
        });
        return {
          parent: parent,
          children: children
        };
      });

      return droitTree;
    }
  },
  methods: {
    show() {
      this.userDroits = this.user.userDroits;
    },
    editPasswd() {
      this.$router.push({ path: "/administration/change-passwd" });
    },
    buildCurrentDroits() {
      let that = this;
      _.forEach(this.currentDroits, function(droit) {
        if (false) {
          that.checkedDroits.push(droit.value);
        }
      });
    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
#mon-compte h5 {
  font-style: italic;
  font-weight: normal;
}
#mon-compte label {
  font-weight: bold;
}
</style>
